<app-config class="hidden" />
<p-confirmDialog></p-confirmDialog>

<ng-container *ngIf="isLoading(); else contentLoaded">
  <div class="bg-surface dark:bg-surface-950">
    <div class="flex">
      <div class="m-4 text-red-500 text-2xl">Loading page...</div>
      <div class="my-4 spinner">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #contentLoaded>
  <div class="view-shell">
    <div class="view-appbar print:hidden">
      <p-tieredmenu class="page-menu" [model]="menuItems" #menu [popup]="true" [autoDisplay]="false" />

      <div class="view-appbar-inner">
        <div class="view-appbar-left">
          <p-button text class="view-icon-button" (click)="menu.toggle($event)">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">menu</span>
            </ng-template>
          </p-button>

          <div class="view-title">
            {{ note.Title || 'Untitled note' }}
          </div>
        </div>

        <div class="view-appbar-actions">
          <p-button text class="view-icon-button view-icon-button--favorite" (click)="toggleFavorite()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined" [ngClass]="{ 'is-filled': isFavorite }">
                {{ isFavorite ? 'favorite' : 'favorite_border' }}
              </span>
            </ng-template>
          </p-button>

          <p-button
            text
            class="view-icon-button hidden lg:inline-flex"
            icon="pi pi-sparkles"
            (click)="openAskNotes()"
            ariaLabel="Ask Notes"
            [title]="!isOnline ? 'AI features are only available in online mode' : 'Ask Notes'"
            [disabled]="!isOnline">
          </p-button>

          <p-button text class="view-icon-button" data-action="home" (click)="pageMenu('Home')">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">home</span>
            </ng-template>
          </p-button>

          <p-button text class="view-icon-button" (click)="pageMenu('Edit')">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">edit</span>
            </ng-template>
          </p-button>

          <p-button text class="view-icon-button" data-action="pdf" (click)="pageMenu('DownloadPDF')">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">picture_as_pdf</span>
            </ng-template>
          </p-button>

          <p-button text class="view-icon-button" data-action="print" (click)="pageMenu('Print')">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">print</span>
            </ng-template>
          </p-button>

          <p-button text class="view-icon-button" (click)="pageMenu('Close')">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">close</span>
            </ng-template>
          </p-button>
        </div>
      </div>
    </div>

    <app-bulk-action-dialog
      [visible]="viewDocxExportDialogVisible"
      [action]="viewDocxExportAction"
      [selectedCount]="1"
      [showPageBreakBetweenNotesOption]="false"
      (cancel)="onViewDocxExportDialogCancel()"
      (submit)="onViewDocxExportDialogSubmit($event)">
    </app-bulk-action-dialog>

    <div id="printable-content" class="view-content">
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <section class="view-section view-section--description">
        <div class="view-section-header view-section-header--toggle" (click)="toggleHeaderFields()">
          <div class="view-section-title">Metadata</div>
          <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleHeaderFields()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">{{ isHeaderVisible ? 'expand_less' : 'expand_more' }}</span>
            </ng-template>
          </p-button>
        </div>

        <div class="view-card" *ngIf="isHeaderVisible">
          <div class="view-meta-grid view-meta-grid--core">
            <div class="view-meta-item">
              <div class="view-meta-label">ID</div>
              <div class="view-meta-value view-meta-value--with-action">
                <span class="view-meta-value__text">{{ note._id }}</span>
                <p-button text class="view-meta-copy-button" (click)="copyNoteId()" aria-label="Copy ID">
                  <ng-template pTemplate="icon">
                    <span class="material-symbols-outlined">content_copy</span>
                  </ng-template>
                </p-button>
              </div>
            </div>

            <div class="view-meta-item">
              <div class="view-meta-label">Status</div>
              <div class="view-meta-value">{{ note.Status }}</div>
            </div>

            <div class="view-meta-item">
              <div class="view-meta-label">Type</div>
              <div class="view-meta-value">{{ note.NoteType }}</div>
            </div>

            <div class="view-meta-item">
              <div class="view-meta-label">Reference Date</div>
              <div class="view-meta-value">{{ note.ReferenceDate || note.created_on | date : 'dd.MMM.yyyy' }}</div>
            </div>

            <div class="view-meta-item" *ngIf="isEventType">
              <div class="view-meta-label">Start Date</div>
              <div class="view-meta-value">{{ note.StartDate | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>

            <div class="view-meta-item" *ngIf="isEventType">
              <div class="view-meta-label">End Date</div>
              <div class="view-meta-value">{{ note.EndDate | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>
          </div>

          <button
            class="view-more-toggle-row"
            type="button"
            (click)="toggleMetadataMore()"
            [attr.aria-expanded]="isMetadataMoreVisible">
            <span class="view-more-toggle-line"></span>
            <span class="view-more-toggle-label">
              {{ isMetadataMoreVisible ? 'Less' : 'More' }}
              <i [class]="isMetadataMoreVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
            </span>
            <span class="view-more-toggle-line"></span>
          </button>

          <div class="view-meta-grid" *ngIf="isMetadataMoreVisible">
            <div class="view-meta-item" *ngIf="!isEventType">
              <div class="view-meta-label">Start Date</div>
              <div class="view-meta-value">{{ note.StartDate | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>

            <div class="view-meta-item" *ngIf="!isEventType">
              <div class="view-meta-label">End Date</div>
              <div class="view-meta-value">{{ note.EndDate | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>

            <div class="view-meta-item">
              <div class="view-meta-label">Categories</div>
              <div class="view-meta-value">{{ CategoriesString }}</div>
            </div>

            <div class="view-meta-item">
              <div class="view-meta-label">Confidential</div>
              <div class="view-meta-value">{{ note.Confidential ? 'Yes' : 'No' }}</div>
            </div>

            <div class="view-meta-item view-meta-item--muted">
              <div class="view-meta-label">Created</div>
              <div class="view-meta-value">{{ note.created_on | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>

            <div class="view-meta-item view-meta-item--muted">
              <div class="view-meta-label">Modified</div>
              <div class="view-meta-value">{{ note.last_modified | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>

            <div class="view-meta-item view-meta-item--muted">
              <div class="view-meta-label">Sync-Time</div>
              <div class="view-meta-value">{{ note.syncTime | date : 'dd.MMM.yyyy HH:mm' }}</div>
            </div>

            <div class="view-meta-item view-meta-item--muted">
              <div class="view-meta-label">Sync-Status</div>
              <div class="view-meta-value">{{ note.syncStatus }}</div>
            </div>

            <div class="view-meta-item view-meta-item--muted">
              <div class="view-meta-label">Note Size</div>
              <div class="view-meta-value">{{ noteSizeLabel }}</div>
            </div>
          </div>

          <ng-container *ngIf="isMetadataMoreVisible">
            <div class="view-ai-summary-section" *ngIf="!aiSummary">
              <div class="view-more-toggle-row" style="cursor: default;">
                <span class="view-more-toggle-line"></span>
                <span class="view-more-toggle-label">AI Summary</span>
                <span class="view-more-toggle-line"></span>
              </div>
              <div class="view-meta-item view-meta-item--full">
                <div class="view-meta-value view-meta-value--full">AI-Summary information is not available for this note.</div>
              </div>
            </div>

            <div class="view-ai-summary-section" *ngIf="aiSummary as summary">
              <div class="view-more-toggle-row" style="cursor: default;">
                <span class="view-more-toggle-line"></span>
                <span class="view-more-toggle-label">AI Summary</span>
                <span class="view-more-toggle-line"></span>
              </div>

              <div class="view-meta-grid">
                <div class="view-meta-item">
                  <div class="view-meta-label">Status</div>
                  <div class="view-meta-value">
                    <span class="view-ai-summary-status">
                      <span
                        class="material-symbols-outlined view-ai-summary-icon"
                        [ngClass]="aiSummaryStatusIconClass(summary.summary_status)">
                        {{ aiSummaryStatusIcon(summary.summary_status) }}
                      </span>
                      {{ aiSummaryStatusLabel(summary.summary_status) }}
                    </span>
                  </div>
                </div>

                <div class="view-meta-item" *ngIf="summary.summary_stale">
                  <div class="view-meta-label">Stale</div>
                  <div class="view-meta-value">Yes</div>
                </div>

                <div class="view-meta-item" *ngIf="summary.summary_model">
                  <div class="view-meta-label">Model</div>
                  <div class="view-meta-value">{{ summary.summary_model }}</div>
                </div>

                <div class="view-meta-item" *ngIf="summary.summary_note_revision">
                  <div class="view-meta-label">Rev</div>
                  <div class="view-meta-value">{{ summary.summary_note_revision }}</div>
                </div>

                <div class="view-meta-item" *ngIf="summary.summary_requested_at">
                  <div class="view-meta-label">Requested</div>
                  <div class="view-meta-value">{{ summary.summary_requested_at | date : 'dd.MMM.yyyy HH:mm' }}</div>
                </div>

                <div class="view-meta-item" *ngIf="summary.summary_generated_at">
                  <div class="view-meta-label">Generated</div>
                  <div class="view-meta-value">{{ summary.summary_generated_at | date : 'dd.MMM.yyyy HH:mm' }}</div>
                </div>

                <div class="view-meta-item" *ngIf="summary.summary_token_input || summary.summary_token_output">
                  <div class="view-meta-label">Tokens</div>
                  <div class="view-meta-value">{{ summary.summary_token_input ?? '—' }} in / {{ summary.summary_token_output ?? '—' }} out</div>
                </div>
              </div>

              <div class="view-ai-summary-full-fields">
                <div class="view-meta-item view-meta-item--full" *ngIf="summary.summary_error">
                  <div class="view-meta-label">Error</div>
                  <div class="view-meta-value view-meta-value--full view-meta-value--multiline">{{ summary.summary_error }}</div>
                </div>

                <div class="view-meta-item view-meta-item--full" *ngIf="summary.summary_one_sentence">
                  <div class="view-meta-label">Summary</div>
                  <div class="view-meta-value view-meta-value--full view-meta-value--multiline">{{ summary.summary_one_sentence }}</div>
                </div>

                <div class="view-meta-item view-meta-item--full" *ngIf="summary.summary_paragraph">
                  <div class="view-meta-label">Paragraph</div>
                  <div class="view-meta-value view-meta-value--full view-meta-value--multiline">{{ summary.summary_paragraph }}</div>
                </div>

                <div class="view-meta-item view-meta-item--full" *ngIf="summary.summary_bullets?.length">
                  <div class="view-meta-label">Bullets</div>
                  <div class="view-meta-value view-meta-value--full view-meta-value--multiline">
                    <ul class="view-ai-summary-bullets">
                      <li *ngFor="let bullet of summary.summary_bullets">{{ bullet }}</li>
                    </ul>
                  </div>
                </div>

                <div class="view-meta-item view-meta-item--full" *ngIf="summary.summary_keywords?.length">
                  <div class="view-meta-label">Keywords</div>
                  <div class="view-meta-value view-meta-value--full view-meta-value--multiline">{{ summary.summary_keywords!.join(', ') }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </section>

      <section class="view-section">
        <div class="view-section-header view-section-header--toggle" (click)="toggleDescription()">
          <div class="view-section-title">DESCRIPTION</div>

          <div style="display: flex; gap: 0.25rem; align-items: center;">
            <p-button
              text
              class="view-toggle-button"
              [title]="areAllCollapsibleExpanded ? 'Collapse All Sections' : 'Expand All Sections'"
              (click)="$event.stopPropagation(); toggleAllCollapsibleSections()">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">{{ areAllCollapsibleExpanded ? 'unfold_less' : 'unfold_more' }}</span>
              </ng-template>
            </p-button>

            <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleDescription()">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">{{ isDescriptionExpanded ? 'expand_less' : 'expand_more' }}</span>
              </ng-template>
            </p-button>
          </div>
        </div>

        <div class="view-card view-card--editor view-card--mobile-compact" *ngIf="isDescriptionExpanded">
          <ng-container *ngIf="!showRawMarkup; else rawDescriptionBlock">
            <app-rich-editor
              #descriptionEditor
              editorId="EditDescription"
              [noteId]="note._id"
              [content]="renderMarkup(note.DescriptionHtml)"
              [readOnly]="true"
              [placeholderText]="''">
            </app-rich-editor>
          </ng-container>

          <ng-template #rawDescriptionBlock>
            <pre class="view-raw-markup">{{ note.DescriptionHtml || '' }}</pre>
          </ng-template>
        </div>
      </section>

      <section class="view-section view-section--attachments" *ngIf="note?._id">
        <div class="view-section-header view-section-header--toggle" (click)="toggleFileAttachments()">
          <div class="view-section-title-wrap">
            <div class="view-section-title">FILE ATTACHMENTS</div>
            <span
              class="view-section-count-badge"
              [ngClass]="{ 'view-section-count-badge--active': attachmentCount > 0 }"
              [attr.aria-label]="attachmentCount + ' attachments'">
              {{ attachmentCount }}
            </span>
          </div>

          <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleFileAttachments()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">{{ isFileAttachmentsExpanded ? 'expand_less' : 'expand_more' }}</span>
            </ng-template>
          </p-button>
        </div>

        <div class="view-card view-card--mobile-compact" *ngIf="isFileAttachmentsExpanded">
          <app-file-upload [noteId]="note._id" [noteAttachments]="note.Attachments" [readOnly]="true"></app-file-upload>
        </div>
      </section>

      <section class="view-section view-section--tags">
        <div class="view-section-header view-section-header--toggle" (click)="toggleTags()">
          <div class="view-section-title-wrap">
            <div class="view-section-title">TAGS</div>
            <span
              class="view-section-count-badge"
              [ngClass]="{ 'view-section-count-badge--active': tagCount > 0 }"
              [attr.aria-label]="tagCount + ' tags'">
              {{ tagCount }}
            </span>
          </div>

          <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleTags()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">{{ isTagsExpanded ? 'expand_less' : 'expand_more' }}</span>
            </ng-template>
          </p-button>
        </div>

        <div class="view-card view-card--mobile-compact" *ngIf="isTagsExpanded">
          <div class="view-tag-mobile-grid view-tag-mobile-grid--mobile">
            <button
              *ngFor="let tag of noteTags"
              type="button"
              class="view-tag-pill"
              [ngClass]="{ 'view-tag-pill--inactive': !tag.isActive }"
              [ngStyle]="getTagCardStyle(tag)"
              (click)="filterByTag(tag)">
              {{ tag.name }}
            </button>
          </div>

          <div class="view-tag-grid view-tag-grid--desktop">
            <article
              *ngFor="let tag of noteTags"
              class="view-tag-card"
              [ngClass]="{ 'view-tag-card--inactive': !tag.isActive }"
              (click)="filterByTag(tag)"
              [ngStyle]="getTagCardStyle(tag)">
              <div class="view-tag-card__header">
                <div class="view-tag-card__identity">
                  <span class="view-tag-card__swatch" [style.backgroundColor]="tag.color || '#94a3b8'"></span>
                  <div>
                    <div class="view-tag-card__title">{{ tag.name }}</div>
                    <div class="view-tag-card__meta">{{ getTagMetaLine(tag) }}</div>
                  </div>
                </div>

                <p-chip
                  [label]="getTagChipLabel(tag)"
                  [styleClass]="tag.isActive ? 'view-tag-chip' : 'view-tag-chip view-tag-chip--inactive'">
                </p-chip>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section class="view-section view-section--keywords">
        <div class="view-section-header view-section-header--toggle" (click)="toggleKeywords()">
          <div class="view-section-title">KEYWORDS</div>

          <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleKeywords()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">{{ isKeywordsExpanded ? 'expand_less' : 'expand_more' }}</span>
            </ng-template>
          </p-button>
        </div>

        <div class="view-card view-card--mobile-compact" *ngIf="isKeywordsExpanded">
          <div class="view-meta-value view-meta-value--full">{{ note.Keywords }}</div>
        </div>
      </section>

      <section class="view-section view-section--related-notes">
        <div class="view-section-header view-section-header--toggle" (click)="toggleRelatedNotes()">
          <div class="view-section-title-wrap">
            <div class="view-section-title">RELATED NOTES</div>
            <span
              class="view-section-count-badge"
              [ngClass]="{ 'view-section-count-badge--active': relatedNotes.length > 0 }"
              [attr.aria-label]="relatedNotes.length + ' related notes'">
              {{ relatedNotes.length }}
            </span>
          </div>

          <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleRelatedNotes()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">{{ isRelatedNotesExpanded ? 'expand_less' : 'expand_more' }}</span>
            </ng-template>
          </p-button>
        </div>

        <div class="view-card view-card--mobile-compact" *ngIf="isRelatedNotesExpanded">
          <ng-container *ngIf="relatedNotes.length > 0; else noRelatedNotes">
            <div class="view-related-mobile-list">
              <article class="view-related-mobile-item" *ngFor="let id of relatedNotes" [ngStyle]="relatedNoteRowStyle(getNoteStatusById(id))">
                <a class="view-related-mobile-title"
                  [ngStyle]="relatedNoteRowStyle(getNoteStatusById(id))"
                  [routerLink]="['/view', id]"
                  target="_blank"
                  rel="noopener">
                  {{ getNoteTitleById(id) || '(Untitled)' }}
                </a>
                <div class="view-related-mobile-meta" *ngIf="getNoteStatusById(id)" [ngStyle]="relatedNoteRowStyle(getNoteStatusById(id))">{{ getNoteStatusById(id) }}</div>
              </article>
            </div>

            <p-table
              class="view-related-desktop-table"
              styleClass="p-datatable-sm"
              [value]="relatedNoteObjects"
              [scrollable]="true"
              scrollHeight="280px">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 46%">Title</th>
                  <th style="width: 18%">Status</th>
                  <th style="width: 26%">Modified</th>
                  <th style="width: 10%">AI Summary</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-ref>
                <tr [ngStyle]="relatedNoteRowStyle(ref.status)">
                  <td [ngStyle]="relatedNoteRowStyle(ref.status)">
                    <a class="hover:underline cursor-pointer"
                      [ngStyle]="relatedNoteRowStyle(ref.status)"
                      [routerLink]="['/view', ref.id]"
                      target="_blank"
                      rel="noopener">
                      {{ ref.title || '(Untitled)' }}
                    </a>
                  </td>
                  <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(ref.status)">{{ ref.status || '—' }}</td>
                  <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(ref.status)">
                    {{ ref.lastModified ? (ref.lastModified | date:'dd MMM yyyy') : '—' }}
                  </td>
                  <td class="text-center">
                    <ng-container [ngSwitch]="ref.aiSummary?.summary_status">
                      <span *ngSwitchCase="'current'"
                        class="material-symbols-outlined view-ai-summary-icon"
                        [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                        tooltipPosition="left"
                        [tooltipOptions]="{ showDelay: 200, tooltipStyleClass: 'view-ai-summary-tooltip' }">
                        info
                      </span>
                      <span *ngSwitchCase="'stale'"
                        class="material-symbols-outlined view-ai-summary-icon view-ai-summary-icon--stale"
                        [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                        tooltipPosition="left"
                        [tooltipOptions]="{ showDelay: 200, tooltipStyleClass: 'view-ai-summary-tooltip' }">
                        info
                      </span>
                      <span *ngSwitchCase="'pending'"
                        class="material-symbols-outlined view-ai-summary-icon view-ai-summary-icon--pending"
                        [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                        tooltipPosition="left">
                        pending
                      </span>
                      <span *ngSwitchCase="'failed'"
                        class="material-symbols-outlined view-ai-summary-icon view-ai-summary-icon--failed"
                        [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                        tooltipPosition="left">
                        error_outline
                      </span>
                    </ng-container>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>

          <ng-template #noRelatedNotes>
            <div class="text-sm text-surface-500 py-2">No related notes.</div>
          </ng-template>
        </div>
      </section>

      <section class="view-section view-section--comments">
        <div class="view-section-header view-section-header--toggle" (click)="toggleComments()">
          <div class="view-section-title">COMMENTS</div>

          <p-button text class="view-toggle-button" (click)="$event.stopPropagation(); toggleComments()">
            <ng-template pTemplate="icon">
              <span class="material-symbols-outlined">{{ isCommentsExpanded ? 'expand_less' : 'expand_more' }}</span>
            </ng-template>
          </p-button>
        </div>

        <div class="view-card view-card--editor" *ngIf="isCommentsExpanded">
          <ng-container *ngIf="!showRawMarkup; else rawCommentsBlock">
            <app-rich-editor
              editorId="EditComments"
              [noteId]="note._id"
              [content]="renderMarkup(note.CommentsHtml)"
              [readOnly]="true"
              [placeholderText]="''">
            </app-rich-editor>
          </ng-container>

          <ng-template #rawCommentsBlock>
            <pre class="view-raw-markup">{{ note.CommentsHtml || '' }}</pre>
          </ng-template>
        </div>
      </section>
    </div>

    <div class="view-footer">
      <div class="view-footer-zoom flex gap-2 items-center">
        <p-button #trigger text class="view-icon-button" (click)="toggleZoomPanel($event)">
          <ng-template pTemplate="icon">
            <span class="material-symbols-outlined">zoom_in</span>
          </ng-template>
        </p-button>

        <p-button
          icon="pi pi-times-circle"
          label="Close"
          severity="secondary"
          class="view-footer-close-button"
          (onClick)="pageMenu('Close')">
        </p-button>

        <p-button
          icon="pi pi-sparkles"
          label="Find Similar"
          class="hidden lg:inline-flex view-footer-ai-button"
          [loading]="similarNotesLoading"
          [disabled]="similarNotesLoading || !note._id || !isOnline"
          [title]="!isOnline ? 'AI features are only available in online mode' : ''"
          (onClick)="findSimilarNotes()">
        </p-button>
      </div>

      <div class="flex items-center gap-2">
        <span
          class="view-footer-online-indicator"
          [ngClass]="{ online: connectivity.fullyOnline, offline: !connectivity.fullyOnline }"
          [attr.aria-label]="connectivity.label"
          [title]="connectivity.label">
          <span
            class="material-symbols-outlined view-footer-status-icon"
            [ngClass]="connectivity.fullyOnline ? 'view-footer-status-icon--online' : 'view-footer-status-icon--offline'">
            {{ connectivity.icon }}
          </span>
        </span>
      </div>
    </div>

    <div
      *ngIf="showZoomPanel"
      #zoomPanel
      class="view-zoom-panel"
      [ngStyle]="zoomPanelStyle"
      (click)="$event.stopPropagation()">
      <div class="view-zoom-panel__header">
        <span class="view-zoom-panel__title">Editor Zoom</span>
        <button class="view-zoom-panel__close" type="button" (click)="showZoomPanel = false">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="view-zoom-panel__body">
        <p-slider
          [(ngModel)]="editorZoomFactor"
          [min]="50"
          [max]="400"
          [step]="1"
          (onChange)="onZoomFactorChange('editor', editorZoomFactor)"
          (onSlideEnd)="persistEditorZoom()">
        </p-slider>

        <div class="view-zoom-panel__value">{{ editorZoomFactor }}%</div>
      </div>
    </div>
  </div>
</ng-template>

<p-dialog
  header="Similar Notes"
  [(visible)]="similarNotesDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw', maxWidth: '900px' }"
  [breakpoints]="{ '960px': '90vw', '640px': '95vw' }">
  <ng-template pTemplate="content">
    <div *ngIf="similarNotesError" class="text-red-600 mb-3 text-sm">
      {{ similarNotesError }}
    </div>

    <p-table
      [value]="similarNotesResults"
      [loading]="similarNotesLoading"
      styleClass="p-datatable-sm"
      [paginator]="similarNotesResults.length > 15"
      [rows]="15">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 34%">Title</th>
          <th style="width: 18%">Status</th>
          <th style="width: 18%">Modified</th>
          <th style="width: 10%">Score</th>
          <th style="width: 4rem"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [ngStyle]="relatedNoteRowStyle(item.Status || '')">
          <td [ngStyle]="relatedNoteRowStyle(item.Status || '')">
            {{ item.title || item.Title || '(Untitled)' }}
          </td>
          <td class="text-sm" [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ item.Status || '—' }}</td>
          <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(item.Status || '')">
            {{ formatSimilarNoteDate(item) }}
          </td>
          <td class="text-sm" [ngStyle]="relatedNoteRowStyle(item.Status || '')">
            {{ item.final_score != null ? (item.final_score | number:'1.2-2') : '' }}
          </td>
          <td class="text-center">
            <a pButton
              icon="pi pi-eye"
              [rounded]="true"
              [text]="true"
              size="small"
              [routerLink]="['/view', getSimilarNoteId(item)]"
              target="_blank"
              rel="noopener"
              pTooltip="View note"
              tooltipPosition="left"></a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <span *ngIf="!similarNotesLoading">No similar notes found.</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>